import Superagent from 'superagent'
import Storage from './storage.service'

const { HOST_API } = _CONSTANTS_

export default {
    createPricing,
    uploadPricings,
    updatePricing,
    deletePricing,
    getPricings,
}

function createPricing(data) {
    return new Promise((resolve, reject) => {
        Superagent
           .post(`${HOST_API}/pricings`)
           .set('access', Storage.getItem('access'))
           .send(data)
           .end((err, res) => {
               resolve(res.body)
           })
    })
}

function uploadPricings(data) {
    return new Promise((resolve, reject) => {
        Superagent
           .post(`${HOST_API}/pricings/upload`)
           .set('access', Storage.getItem('access'))
           .attach('pricingsFile', data.file)
           .end((err, res) => {
               resolve(res.body)
           })
    })
}

function updatePricing(pricingId, data) {
    return new Promise((resolve, reject) => {
        Superagent
           .put(`${HOST_API}/pricings/${pricingId}`)
           .set('access', Storage.getItem('access'))
           .send(data)
           .end((err, res) => {
               resolve(res.body)
           })
    })
}

function deletePricing(pricingId) {
    return new Promise((resolve, reject) => {
        Superagent
           .delete(`${HOST_API}/pricings/${pricingId}`)
           .set('access', Storage.getItem('access'))
           .end((err, res) => {
               resolve(res.body)
           })
    })
}

function getPricings(query) {
    return new Promise((resolve, reject) => {
        Superagent
           .get(`${HOST_API}/pricings`)
           .set('access', Storage.getItem('access'))
           .query(query)
           .end((err, res) => {
               resolve(res.body)
           })
    })
}